export default {
  'nav.home': 'Inicio',
  'nav.categories': 'Categorías',
  'nav.guides': 'Guías',
  'nav.safety': 'Seguridad',
  'nav.browse': 'Explorar la tienda',
  'nav.shoppingGuide': 'Guía de compras',

  'hero.badge': 'Recurso independiente · Actualizado periódicamente',
  'hero.title': 'USFans Spreadsheet — Encuentra, organiza y explora recursos de USFans',
  'hero.subtitle': 'Descubre creadores, categorías, guías y consejos de seguridad desde un centro organizado. Explora la hoja de cálculo completa de USFans y compra lo último.',
  'hero.ctaPrimary': 'USFans Spreadsheet',
  'hero.ctaSecondary': 'Comprar ahora',
  'hero.trust': 'Información organizada · Enlaces verificados · Navegación sencilla',

  'categories.title': 'Explora las categorías de USFans',
  'categories.subtitle': 'Ve directo a la categoría que buscas en la hoja de cálculo de USFans.',
  'categories.dropdownLabel': 'Búsqueda rápida de categorías',
  'categories.dropdownPlaceholder': 'Selecciona una categoría',

  'cat.shoes': 'Zapatos',
  'cat.hoodies': 'Sudaderas / Suéteres',
  'cat.tshirts': 'Camisetas',
  'cat.jackets': 'Chaquetas',
  'cat.pants': 'Pantalones / Shorts',
  'cat.headwear': 'Gorras y sombreros',
  'cat.sets': 'Conjuntos',
  'cat.underwear': 'Ropa interior',
  'cat.jersey': 'Camisetas deportivas',
  'cat.accessories': 'Accesorios',
  'cat.bags': 'Bolsos',
  'cat.belts': 'Cinturones',
  'cat.perfumes': 'Perfumes',
  'cat.other': 'Otras cosas',

  'whatis.title': '¿Qué es la USFans Spreadsheet?',
  'whatis.p1': 'La USFans Spreadsheet es un recurso organizado diseñado para ayudarte a descubrir e investigar información relacionada con USFans en un solo lugar.',
  'whatis.p2': 'En lugar de buscar en páginas dispersas, puedes explorar categorías estructuradas, información de creadores, guías y consejos de seguridad desde un único centro conveniente.',
  'whatis.p3': 'Explora, compara y verifica: todo lo que necesitas está reunido y ordenado para una navegación más rápida.',

  'value.title': 'Todo lo que necesitas para explorar USFans en un solo lugar',
  'value.subtitle': 'Un único centro organizado con las herramientas y temas que la gente más busca.',
  'value.item1': 'USFans Spreadsheet',
  'value.item2': 'Directorio de creadores',
  'value.item3': 'Guías de búsqueda y descubrimiento',
  'value.item4': 'Reseñas y comparaciones',
  'value.item5': 'Información de envío',
  'value.item6': 'Recursos de cupones',
  'value.item7': 'Guías de almacén',
  'value.item8': 'Seguridad y protección',

  'popular.title': 'Búsquedas populares de USFans',
  'popular.subtitle': 'Explora rápidamente los temas que la gente más busca.',
  'popular.review.title': 'Reseña de USFans',
  'popular.review.desc': 'Conoce las funciones, la experiencia del usuario, las ventajas y las consideraciones importantes.',
  'popular.shipping.title': 'Costo de envío de USFans',
  'popular.shipping.desc': 'Comprende la información de envío, los factores de precio y qué afecta el costo total.',
  'popular.coupon.title': 'Cupón de USFans',
  'popular.coupon.desc': 'Encuentra información sobre promociones, ofertas y recursos de cupones disponibles.',
  'popular.discount.title': 'Código de descuento de USFans',
  'popular.discount.desc': 'Explora la información actual de descuentos y aprende a verificar las ofertas promocionales.',
  'popular.warehouse.title': 'Almacén de USFans',
  'popular.warehouse.desc': 'Aprende cómo funcionan los servicios y procesos relacionados con el almacén.',
  'popular.legit.title': '¿USFans es legítimo?',
  'popular.legit.desc': 'Comprende cómo evaluar la legitimidad, las señales de confianza, la seguridad del sitio y los posibles riesgos.',

  'comparison.title': 'Recursos de USFans comparados',
  'comparison.subtitle': 'Un resumen rápido de cómo cada recurso te ayuda a explorar USFans.',
  'comparison.col1': 'Recurso',
  'comparison.col2': 'Ideal para',
  'comparison.col3': 'Organización',
  'comparison.col4': 'Actualizaciones',
  'comparison.col5': 'Para principiantes',
  'comparison.r1': 'USFans Spreadsheet',
  'comparison.r1best': 'Investigación organizada',
  'comparison.r2': 'Directorio de creadores',
  'comparison.r2best': 'Descubrir creadores',
  'comparison.r3': 'Guía de búsqueda',
  'comparison.r3best': 'Encontrar información',
  'comparison.r4': 'Guía de reseñas',
  'comparison.r4best': 'Evaluar opciones',

  'safety.title': 'Mantente seguro al explorar los recursos de USFans',
  'safety.p': 'Verifica siempre los enlaces antes de hacer clic, evita páginas de inicio de sesión sospechosas, nunca compartas tus contraseñas, protege tu información personal y ten cuidado con descargas o solicitudes de pago desconocidas.',
  'safety.link': 'Lee nuestra guía de seguridad',

  'articles.title': 'Guías y artículos de USFans',
  'articles.subtitle': 'Recursos originales y completos para aprovechar al máximo la hoja de cálculo de USFans.',
  'articles.cardTitle': 'USFans Spreadsheet: Guía completa',
  'articles.cardDesc': 'Todo lo que necesitas saber para encontrar, organizar y explorar los recursos de USFans: categorías, consejos y seguridad.',
  'articles.readMore': 'Leer la guía',

  'final.title': '¿Listo para explorar la USFans Spreadsheet?',
  'final.subtitle': 'Encuentra información organizada, guías útiles y temas de USFans buscados con frecuencia desde un centro único.',
  'final.cta': 'Explorar USFans Spreadsheet',

  'footer.tagline': 'Un recurso informativo independiente sobre la hoja de cálculo de USFans y todo lo que la rodea.',
  'footer.disclaimer': 'USFansLink.cfd es un recurso informativo independiente y no está afiliado ni respaldado por USFans, salvo que se indique explícitamente.',
  'footer.quickLinks': 'Enlaces rápidos',
  'footer.resources': 'Recursos',
  'footer.copyright': 'Todos los derechos reservados.',
};